import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import "./lib/i18n"; // eagerly starts loading common translations
import { initSovrn } from "./lib/sovrn";
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Sovrn Commerce affiliate tag — inert unless VITE_SOVRN_KEY is set; skips localhost.
initSovrn();

const updateSW = registerSW({
  onNeedRefresh() {
    if (confirm("New version available. Reload?")) {
      updateSW(true);
    }
  },
  onOfflineReady() {
    console.log("App ready to work offline");
  },
});

// Service Worker <-> Client token bridge for background token refresh
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("message", (event) => {
    const { data } = event;

    // SW requesting current tokens
    if (data?.type === "sw_get_tokens" && event.ports?.[0]) {
      event.ports[0].postMessage({
        accessToken: localStorage.getItem("access_token"),
        refreshToken: localStorage.getItem("refresh_token"),
      });
    }

    // SW pushing refreshed tokens back
    if (data?.type === "sw_tokens_refreshed") {
      if (data.accessToken) localStorage.setItem("access_token", data.accessToken);
      if (data.refreshToken) localStorage.setItem("refresh_token", data.refreshToken);
    }
  });
}
